<template>
    <div class="wrapper">
        <dash-header></dash-header>
        <sidebar></sidebar>
        <div class="content-wrapper">
            <!-- Content Header (Page header) -->
            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h1 class="m-0 title">Edit Card</h1>
                        </div><!-- /.col -->
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><router-link to="/dashboard">Home</router-link></li>
                            <li class="breadcrumb-item"><router-link to="/bank-account">Bank Account</router-link></li>
                            <li class="breadcrumb-item active">Edit Card</li>
                            </ol>
                        </div><!-- /.col -->
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </section>
            <!-- /.content-header -->

            <section class="content">
                <div class="container-fluid">
                    <form action="" @submit.prevent="EditDataBank">
                        <div class="form-group">
                            <label for="owner_name">Owner Name</label>
                            <input type="text" v-model="databank.owner_name" class="form-control" id="owner_name" name="owner_name">
                        </div>
                        <div class="form-group">
                            <label for="account_number">Account Number</label>
                            <input type="text" v-model="databank.account_number" class="form-control" id="account_number" name="account_number">
                        </div>
                        <div class="form-group">
                            <label for="bank_name">Bank Name</label>
                            <input type="text" v-model="databank.bank_name" class="form-control" id="bank_name" name="bank_name">
                        </div>
                        <div class="form-group">
                            <label for="branch_name">Branch Name</label>
                            <input type="text" v-model="databank.branch_name" class="form-control" id="branch_name" name="branch_name">
                        </div>
                        <router-link to="/bank-account" class="btn btn-secondary m-2">Cancel</router-link>
                        <button type="submit" class="btn btn_red btn_bank" id="edit-bank">Save Change</button>
                    </form>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import DashHeader from "../layouts/Header.vue";
// import DashFooter from "../layouts/Footer.vue";
import { dragscroll } from "vue-dragscroll";
import Sidebar from "../layouts/Sidebar.vue";
import axios from "axios"
import swal from 'sweetalert'

export default {
    name: "AddBank",
    directives: {
        dragscroll,
    },
    components: {
        DashHeader,
        // DashFooter,
        Sidebar,
    },
    data(){
        return{
            user_id: localStorage.getItem('user_id'),
            databank:{
                investor_id: this.user_id,
                bank_name:"",
                branch_name:"",
                owner_name : "",
                account_number: ""
            },
            dataset: 0,
            databankid: [],
        }
    },
    async mounted(){
        await axios.get(`investor/bank/${this.$route.params.id}`)
        .then((response)=>{
            // console.log("List Bank", response.data.data)
            this.databankid = response.data.data
            this.databank = this.databankid
        }).catch(() => {
            // console.log("Error List Bank", err.response)
        })
    },
    methods:{
        NumbersOnly(evt) {
          evt = (evt) ? evt : window.event;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
            evt.preventDefault();
          } else {
            return true;
          }
        },
        editdatabank(){
            // console.log(this.$route.params.id)
            axios.get(`investor/bank/${this.$route.params.id}`).then(()=>{
                if (this.databankall == this.$route.params.id) {
                    this.databank = this.databankall
                    // console.log(this.databank)
                    
                }
            })
            // axios.get(`investor/bank/${this.user_id}`).then((response)=>{
            //     this.databankall = response.data.data
            //     console.log(this.databankall)
            // })
        },
        EditDataBank() {
          document.getElementById("edit-bank").disabled = true
          let k = 0
        //   console.log(this.$route.params.id)
          for(let i = 0;i < this.databankid.length;i++){
            let data = this.databankid[k].account_number
            let iddata = this.databankid[k].id
            if(data == this.databank.account_number){
              if(iddata == this.$route.params.id){
                this.dataset = 1
              }else{
                this.dataset = 0
                break
              }
            }
            else if(data != this.databank.account_number){
              this.dataset = 1
            }
            k++
            // console.log(this.dataset)
          }
          if(this.dataset == 1){
            // console.log(localStorage.id)
              
            let data = new FormData()
            data.append('investor_id', this.user_id)
            data.append('bank_name', this.databank.bank_name)
            data.append('branch_name', this.databank.branch_name)
            data.append('owner_name', this.databank.owner_name)
            data.append('account_number', this.databank.account_number)
            axios.put(`investor/bank/${this.$route.params.id}/`, data)
            .then((response) => {
                // console.log(response.data);
                if(response.data.status == 200) {
                    document.getElementById("edit-bank").disabled = false
                    swal('Conrastulations!!!', 'Bank data has been successfully edited.', 'success', {
                        button: "OK"
                    })
                    this.$router.push({ path: `/bank-account` })
                } else {
                    document.getElementById("edit-bank").disabled = false
                    // validation.value = response.data.response
                    // console.log(validation);
                }
            }).catch(() => {
                // console.log(error)
                document.getElementById("edit-bank").disabled = false
            })
          }else{
            document.getElementById("edit-bank").disabled = false
             swal('Account already filled', 'Please change the account number', 'info', {
                      button: "OK"
                  })
          }
        },        
    }
}
</script>

<style>
.btn_bank{
    width: 200px;
}
a.btn-secondary{
    padding: 10px;
}
</style>